import { Link, PageHeader, PageLayout } from "@softmax/design-system";
import { sizes, spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";

const styles = stylex.create({
  content: {
    maxWidth: sizes.account,
    marginInline: "auto",
    width: "100%",
    display: "grid",
    gap: spacing.space24,
  },
  navigation: { display: "flex", flexWrap: "wrap", gap: spacing.space24 },
});

export function AccountFrame({
  title,
  description,
  section,
  settingsHref,
  credentialsHref,
  children,
}: {
  readonly title: string;
  readonly description: string;
  readonly section: "settings" | "credentials";
  readonly settingsHref: string;
  readonly credentialsHref?: string;
  readonly children: ReactNode;
}) {
  return (
    <PageLayout>
      <div {...stylex.props(styles.content)}>
        <nav aria-label="Account" {...stylex.props(styles.navigation)}>
          {section === "settings" ? (
            <strong aria-current="page">Settings</strong>
          ) : (
            <Link href={settingsHref} focus="native">
              Settings
            </Link>
          )}
          {credentialsHref &&
            (section === "credentials" ? (
              <strong aria-current="page">Players & credentials</strong>
            ) : (
              <Link href={credentialsHref} focus="native">
                Players & credentials
              </Link>
            ))}
        </nav>
        <PageHeader title={title} description={description} />
        {children}
      </div>
    </PageLayout>
  );
}
